<template>
  <NuxtLayout name="default">
    <div class="error-page-wrapper">
      <v-card elevation="0" border rounded="xl" class="pa-10 error-page-card">
        <v-card-text class="pa-0 text-center">
          <template v-if="is404Error">
            <p class="text-h1 text-secondary font-weight-bold mb-2">
              404
            </p>
            <p class="text-body-1 text-medium-emphasis mb-2">
              {{ $t("notFound.pageNotFoundSubTitle") }}
            </p>
            <p class="text-body-2 text-medium-emphasis mb-6">
              {{ $t("notFound.pageNotFoundDescription") }}
            </p>
          </template>
          <template v-else>
            <p class="text-h3 font-weight-medium mb-2">
              {{ otherError }}
            </p>
            <p class="text-body-1 text-medium-emphasis mb-2">
              {{ $t("notFound.errorInformation") }}
            </p>
            <p class="text-body-2 text-medium-emphasis mb-6">
              {{ error?.message }}
            </p>
          </template>

          <v-btn
            color="secondary"
            variant="flat"
            class="font-weight-bold text-uppercase"
            :ripple="false"
            to="/"
          >
            {{ $t("notFound.backToMainPage") }}
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";

const $props = defineProps({
  error: {
    type: Object as () => NuxtError,
    default: () => null,
  },
});
const pageNotFound = "404 Not Found";
const otherError = "An error occurred";
const is404Error = computed(() => {
  return $props.error?.statusCode === 404;
});

useHead({
  titleTemplate: `${is404Error.value ? pageNotFound : otherError} - Mina Innehav`,
});
</script>

<style scoped lang="scss">
.error-page-wrapper {
  width: 100%;
  max-width: 500px;
}

.error-page-card {
  width: 100%;
}
</style>
